module.exports = __webpack_public_path__ + "img/gb-nir.c546f46d.svg";